import { action, computed, observable, runInAction } from 'mobx';
import { Category } from '../models';
import {
  default as getRepository,
  CategoryRepository
} from '../repositories/Category';

export class CategoryStore {
  public repository: CategoryRepository = getRepository();

  @observable public categories: Array<Category> = [];
  @observable public fetchedCategories?: Promise<void>;
  @observable public fetchCategoriesError: boolean = false;
  @observable public fetchingCategories: boolean = false;

  @action
  fetchCategories = async (force: boolean = false): Promise<void> => {
    // If we've already fetched categories, and we're not forcing (or we're
    // trying to force while a fetch is in-flight) then return cached result
    if (!(force && !this.fetchingCategories) && this.fetchedCategories) {
      return this.fetchedCategories;
    }

    this.fetchedCategories = this.performCategoryFetch();

    await this.fetchedCategories;
  };

  @action
  performCategoryFetch = async (): Promise<void> => {
    try {
      runInAction(() => (this.fetchingCategories = true));

      this.clearFetchCategoriesError();

      const categories = await this.repository.fetchAll();

      this.onFetchCategoriesSuccess(categories);
    } catch (ex) {
      this.onFetchCategoriesError();
    } finally {
      runInAction(() => (this.fetchingCategories = false));
    }
  };

  @action
  onFetchCategoriesSuccess(categories: Array<Category>) {
    this.categories = categories;
  }

  @action
  onFetchCategoriesError() {
    this.fetchCategoriesError = true;
  }

  @action
  clearFetchCategoriesError() {
    this.fetchCategoriesError = false;
  }

  @computed
  get allCategories() {
    return this.categories.reduce(
      (allCategories, category) =>
        allCategories.concat(...(category.children || [])),
      this.categories.slice()
    );
  }
}

export default CategoryStore;



// WEBPACK FOOTER //
// ./src/app/stores/CategoryStore.ts